import React, {useState, useEffect, useRef} from 'react'

// Deps
import { connect } from 'react-redux'

// Functions
import pxToRem from 'functions/px-to-rem'

const mapStateToProps = state => {
	return {
		windowWidth: state.site.windowWidth,
	};
};

const Collapser = (props) => {
	const Tag = props.tag;
	const HeadingTag = props.heading;

	const mounted = useRef(false);
	const timer = useRef(false);
	const contentElem = useRef(false);
	const wrapElem = useRef(false);

	const [open, setOpen] = useState(props.open);
	const [active, setActive] = useState(props.open);
	const [show, setShow] = useState(props.open);
	const [containerHeight, setContainerHeight] = useState(false);

	const calculateHeight = () => {
		//contentElem.current.style.maxHeight = pxToRem(wrapElem.current.clientHeight) + 'rem';
		if(wrapElem && wrapElem.current) {
			setContainerHeight(pxToRem(wrapElem.current.clientHeight) + 'rem');
		}
		else {
			return '0rem';
		}
	}

	useEffect(() => {
		mounted.current = true;

		return(() => {
			mounted.current = false;
		})
	}, []);

	useEffect(() => {
		if(props.open === true) {
			setOpen(true);
		}
		else if(props.open === false) {
			setOpen(false)
		}
	}, [props.open]);

	useEffect(() => {

		if(timer.current !== false) {
			clearTimeout(timer.current);
			timer.current = false;
		}

		if(open) {
			setActive(true);

			timer.current = setTimeout(() => {
				if(mounted.current && open) {
					calculateHeight();
					timer.current = setTimeout(() => {
						setShow(true);

						timer.current = setTimeout(() => {
							setContainerHeight(false);
							timer.current = false;
						}, 300);
					}, 30);

				}
			}, 30);
		}
		else {
			timer.current = setTimeout(() => {
				calculateHeight();
				timer.current = setTimeout(() => {
					setShow(false);
					if (contentElem.current) {
						contentElem.current.style.maxHeight = 0;
					}
					timer.current = setTimeout(() => {
						if(mounted.current && !open) {
							setActive(false);
							setContainerHeight(false);
							timer.current = false;
						}
					}, 300);
				}, 30);
			}, 30);
		}

		if(props.onToggle) {
			props.onToggle(open);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	const BtnElem = props.disableToggle ? 'div' : 'button';

	return (
		<Tag className={'collapser ' + props.className + (props.delay ? 'vw-item vw-mask delay-' + props.delay : '') + (active ? ' active' : '') + (show ? ' show' : '') + ((show + !containerHeight) ? ' shown' : '')}>
			<BtnElem
				className="collapser-btn"
				type={ props.disableToggle ? undefined : "button" }
				onClick={
					props.disableToggle ? undefined : () => { if(!props.disableToggle) { setOpen(!open); } }
				}>
				<HeadingTag className="btn-text">{props.title}</HeadingTag>
				<i className="btn-icon icon-angle-right-thin"></i>
			</BtnElem>

			<div
				className="collapser-content"
				ref={contentElem}
				style={containerHeight ? {maxHeight: containerHeight} : undefined}>
				<div className={'collapser-innerwrap' + (props.wysiwyg ? ' wysiwyg' : '')} ref={wrapElem}>
					{props.children}
				</div>
			</div>
		</Tag>
	)
}

Collapser.defaultProps = {
	className: '',
	title: '!!Props.Title!!',
	wysiwyg: false,
	heading: 'strong',
	tag: 'div',
	open: false,
	disableToggle: false,
}

export default connect(mapStateToProps)(Collapser);